import { Spin } from "antd";

const FullscreenLoader = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Spin size="large" />
        </div>
    );
};
export default FullscreenLoader;